import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import {Provider as ThemeProvider} from "react-redux";
import App from "./App";
import reducer from "./store/reducer";
import { createStore } from "redux";
import { msalInstance } from "./data/config/authConfig";
import AuthService from "./data/services/auth-service";
import axios from "axios";
const themeStore = createStore(reducer);

// Axios interceptors for adding token in header
axios.interceptors.request.use(
    async (config: any) => {
      const token = await AuthService.refreshAccessToken();
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        return config;
      } else {
        return;
      }
    },
    (error) => Promise.reject(error)
  );
  
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    async function (error) {
      const originalRequest = error.config;
      if (!error.response) {
        return Promise.reject("Network Error");
      } else if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
  
        const token = await AuthService.refreshAccessToken();
  
        if (token) {
          originalRequest.headers["Authorization"] = "Bearer " + token;
        }
  
        return axios(originalRequest);
      } else {
        return Promise.reject(error);
      }
    }
  );
  

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
    root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>                    
                <ThemeProvider store={themeStore}>
                    <Router>        
                        <App/>          
                    </Router>
                </ThemeProvider>                     
        </MsalProvider>
    </React.StrictMode>
);

